<template>
    <div class="j-quick-tab-wrap">
        <div class="j-quick-tab-wrap-scroll">
            <j-quick-item :id="`j-quick-tab-${menu.menuId}`" v-for="(menu, index) in $store.state.JMenu.menuQuick" :key="index" :index="index" :meta="menu"/>
        </div>
    </div>
</template>

<script>
import JQuickItem from "./components/JQuickItem";
export default {
  name: 'JQuickTab',
  components: {
    JQuickItem
  }
}
</script>

<style scoped lang="scss">
    .j-quick-tab-wrap {
        height: 100%;
        width: 100%;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .j-quick-tab-wrap-scroll {
            display: flex;
            height: 100%;
            width: 100%;
            padding: 5px;
            box-sizing: border-box;
            overflow-y: hidden;
            overflow-x: auto;
        }

        ::-webkit-scrollbar{
            height: 8px;
            width: 8px;
        }

        ::-webkit-scrollbar-track { background-color: rgba(157, 165, 183, 0.1); border: 3px solid transparent; background-clip: padding-box; }

        ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            border: 3px solid transparent;
            background-color: rgba(157, 165, 183, 0.3);
            background-clip: padding-box;
        }

        ::-webkit-scrollbar-thumb:hover {
            background: rgba(157, 165, 183, 0.3);
        }
    }
</style>
